import { useEffect, useRef, useState } from "react";
import { InsertEmoticon, Send } from "@mui/icons-material";

const emojiOptions = ["🙂", "😊", "🙏", "👍", "❤️", "👋", "🎉", "✅"];

/** Storefront-style composer; sends through the existing parent callback only. */
export default function ChatComposer({ disabled, onSend, onDraftChange }) {
  const [text, setText] = useState("");
  const [emojiOpen, setEmojiOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  function update(value) { setText(value); onDraftChange?.(value); }
  function submit(event) {
    event.preventDefault();
    if (disabled || busy || !text.trim()) return;
    // Legacy booth chat retains the draft until CreateChat returns its ID.
    setError("");
    const result = onSend(text.trim());
    if (result && typeof result.then === "function") {
      setBusy(true);
      result.then((sent) => { if (mounted.current && sent !== false) setText(""); }, () => {
        if (mounted.current) setError("ارسال پیام انجام نشد؛ پیش‌نویس حفظ شده است.");
      }).finally(() => { if (mounted.current) setBusy(false); });
    } else if (result !== false) setText("");
  }
  return <form className="dk-chat-composer" onSubmit={submit} aria-label="نوشتن پیام">
    <div className="dk-chat-emoji-control">
      <button type="button" className="dk-chat-icon" aria-label="ایموجی" aria-expanded={emojiOpen}
        disabled={disabled || busy} onClick={() => setEmojiOpen((value) => !value)}><InsertEmoticon /></button>
      {emojiOpen && <div className="dk-chat-emoji-menu" role="group" aria-label="انتخاب ایموجی">
        {emojiOptions.map((emoji) => <button type="button" key={emoji} aria-label={`درج ${emoji}`} disabled={disabled || busy}
          onClick={() => { update(text + emoji); setEmojiOpen(false); }}>{emoji}</button>)}
      </div>}
    </div>
    <div className="dk-chat-input-wrap">
      <textarea id="chatInput" aria-label="متن پیام" placeholder="پیام خود را بنویسید…" rows={1}
        value={text} disabled={disabled || busy} onChange={(event) => update(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter" && !event.shiftKey && !event.nativeEvent.isComposing) submit(event);
        }} />
      <button type="submit" className="dk-chat-send" aria-label="ارسال پیام" title="ارسال پیام"
        disabled={disabled || busy || !text.trim()}><Send fontSize="small" /></button>
    </div>
    <span className="dk-chat-composer-hint">Enter برای ارسال · Shift+Enter برای سطر جدید</span>
    {error && <span role="alert">{error}</span>}
  </form>;
}
